import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { ClientsBanner } from '../../components/ClientsBanner'

export default function InstantLoan() {
    return (
        <div>
            <Seo
                title="Instant Loan Online | Find The Best Offers | Good Good Finance"
                description="Compare instant loans on our website to find the ideal option for your financial needs. Access the best offers available and make informed decisions today."
                type="webapp"
                name="Good Good Finance"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Instant Loan</h1>

                    <p className="header-subtitle">
                        Good Good Finance helps you compare the most advantageous financing
                        solutions to obtain instant loans in Canada. Receive between $100 and $1,500
                        in less than 24 hours with the help of our trusted partners.
                    </p>

                    <Link to="/new-lead" className="btn">
                        Apply for a loan
                    </Link>
                </div>
            </section>

            <section className="Situation-steps">
                <div className="content" data-aos="fade-up">
                    <h2 className="sect-title">3 Simple Steps to a Fast Online Loan</h2>

                    <p className="sect-subtitle">
                        Emergencies or unexpected expenses can arise at any time, leaving you in
                        need of a quick solution. If you're wondering, "How can I get an instant
                        loan?", we’re here to guide you. Compare the best options for your immediate
                        needs with ease, whether you're interested in fast cash loans, no credit
                        check instant loan Canada, or payday fast loans.
                    </p>

                    <ol style={{ marginTop: 50 }}>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:note" width="40" />
                            </div>
                            <h3>Compare Market Offers</h3>
                            <p>
                                Discover financing options tailored to your needs in just a few
                                clicks!{' '}
                                <Link to="/new-lead">Fill out our online application form</Link> to
                                access instant loan offers. We'll display available amounts,
                                repayment terms, and lender conditions—all{' '}
                                <b>confidential, free of charge, and with no obligation</b>.
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:home" width="40" />
                            </div>
                            <h3>Choose a Lender and Apply for a Loan</h3>
                            <p>
                                Review the terms and select the option that best fits your
                                situation. Click on the lender's name to be redirected to their
                                secure application form. Submit a valid ID and basic personal
                                details for evaluation. Depending on the lender's hours, you might{' '}
                                <b>get a response in as little as an hour</b>!
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:paper-plane" width="40" />
                            </div>
                            <h3>Receive Your Loan Within 24 hours</h3>
                            <p>
                                After approval and signing the agreement, funds will be sent to your
                                account via <b>e-transfer within 24 hours</b>. Early applications
                                could even result in same-day funding!
                            </p>
                        </li>
                    </ol>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">The Benefits of Our Products</h2>

                    <p className="sect-subtitle">
                        Good Good Finance simplifies your search for instant loans, connecting you
                        to top offers from <b>reliable Canadian institutions</b>. Our process is
                        entirely online, free, and confidential.
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 30 }}>
                        <li style={{ marginBottom: 30 }}>
                            <h4>No Credit Check Loans</h4>

                            <span style={{ marginTop: 130 }}>
                                Loans won’t affect your credit score.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>IBV Loans</h4>

                            <span style={{ marginTop: 130 }}>
                                Instant bank verification is used to evaluate your repayment
                                ability.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Quick Approvals</h4>

                            <span style={{ marginTop: 130 }}>
                                Receive funds within 24 hours, without the need for extensive
                                paperwork.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Trusted Partners</h4>

                            <span style={{ marginTop: 130 }}>
                                Work only with verified lenders to ensure secure and dependable
                                services.
                            </span>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Choose the Amount That Suits You</h2>

                    <p className="sect-subtitle">
                        Access personalized instant loans for amounts that meet your specific needs:
                    </p>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>$200 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$300 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$500 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$700 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$1,000 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$1,500 loan</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Loans to Cover Every Situation</h2>

                    <p className="sect-subtitle">
                        We understand that urgent expenses require quick solutions. No need to
                        explain your circumstances—just provide basic details and explore solutions
                        tailored to you. Options include:
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 20 }}>
                        <li>Loan with no job</li>
                        <li>Cash advance</li>
                        <li>Emergency loan</li>
                        <li>Personal loan</li>
                        <li>Payday loan</li>
                    </ul>
                </div>
            </section>

            <section className="Eligible sect-bg-dark">
                <div className="card" data-aos="fade-up">
                    <div className="content">
                        <div className="section-title">
                            <h2>Am I Eligible?</h2>
                        </div>
                        <p>
                            <b>Even if you have bad credit or no employment</b>, you may still
                            qualify for a fast loan. Here’s what you’ll need:
                        </p>
                        <ul>
                            <li>Be at least 18 years old</li>
                            <li>Be a Canadian resident</li>
                            <li>Have a stable income (e.g., benefits or other sources)</li>
                            <li>Have no stop payments</li>
                            <li>Minimal NSF (non-sufficient funds) charges</li>
                        </ul>
                        <p>
                            If you meet these criteria, apply today and discover your instant loan
                            options!
                        </p>
                        <Link to="/new-lead" className="btn">
                            Apply for a loan
                        </Link>
                    </div>
                </div>
            </section>

            {/* <ClientsBanner /> */}

            <Footer />
        </div>
    )
}
